export default __webpack_public_path__ + "static/media/phone_white.90c5ffb5.svg";